const e = "styles-module__overlay___Os6Fj", l = {
  "image-gallery": "styles-module__image-gallery___spQr7",
  "primary-image": "styles-module__primary-image___re-bZ",
  "image-rail": "styles-module__image-rail___vajvi",
  "image-with-overlay": "styles-module__image-with-overlay___HPeIf",
  overlay: e,
  "image-gallery-fullscreen": "styles-module__image-gallery-fullscreen___hFcyH",
  "image-gallery-two": "styles-module__image-gallery-two___1fZaB"
};
export {
  l as default,
  e as overlay
};
